import Mustache from "mustache";
import MicroModal from "micromodal";
import dropdownButton from "@Decix.Elements/DropdownButton";

MicroModal.init({
    disableScroll: true,
});

$(function () {
    DECIX.connectionFinder = DECIX.connectionFinder || {};

    DECIX.connectionFinder.userData = $("#userData");
    DECIX.connectionFinder.missingConnectionButtons = $(".missingConnectionButton");
    DECIX.connectionFinder.resultsContainer = $(".connection-finder__results");
    DECIX.connectionFinder.filterset = $(".connection-finder__form");
    DECIX.connectionFinder.mobileFilterToggle = $(".mobile-filter-toggle");
    DECIX.connectionFinder.locationSelect = $("#connectionFinder__location");
    DECIX.connectionFinder.countrySelect = $("#connectionFinder__country");
    DECIX.connectionFinder.citySelect = $("#connectionFinder__city");
    DECIX.connectionFinder.onlyPartnersCheckbox = $("#connectionFinder__onlypartners");

    DECIX.connectionFinder.gcfBaseUrl = $("#systemConfig").data("gcf-url");

    DECIX.connectionFinder.noResultsContent = $("#noResultsContent");
    DECIX.connectionFinder.initialContent = $("#initialContent");
    DECIX.connectionFinder.contactFormModal = $("#modalContactForm");
    DECIX.connectionFinder.additionalInformationModal = $("#modalAdditionalInformation");
    DECIX.connectionFinder.missingConnectionModal = $("#modalMissingConnection");

    /**
     * Save system configuration to array for easy access
     */
    DECIX.connectionFinder.setSystemConfig = function(){
        DECIX.connectionFinder.systemConfig = [];
        const rawData = $("#systemConfig").data();
        $.map(rawData, function(value, key) {
            DECIX.connectionFinder.systemConfig[key] = value;
        });
    };

    /**
     * Save AJAX request URIs used to fetch data from server to array for easy access
     */
    DECIX.connectionFinder.setAjaxURIs = function(){
        DECIX.connectionFinder.URIs = [];
        const rawData = $("#jsonAvailableMethods").data();
        $.map(rawData, function(value, key) {
            DECIX.connectionFinder.URIs[key] = value;
        });
    };

    /**
     * Fill <select>domobj with <option> received via XHR request (JSON encoded) and bind itself to next selectpicker,
     * based on data-attributes given in DOM. Also, refresh results if selectpicker requests this.
     *
     * @param domobj The DOM object to refresh
     * @param param Additional parameters by previous selections
     */
    DECIX.connectionFinder.fetchOptions = function(domobj, param) {
        param = param || "";
        let $domobj = $(domobj);
        const sourceURI = DECIX.connectionFinder.URIs[$domobj.data("source")];

        DECIX.connectionFinder.enableInput($domobj);

        $.ajax({
            accepts: {
                json: "application/json"
            },
            url: sourceURI + "/" + param + "?onlyPartners=" + DECIX.connectionFinder.onlyPartnersCheckbox.is(":checked"),
            beforeSend: function () {
                if (!DECIX.connectionFinder.mobileFilterToggle.is(":visible")) {
                    $(DECIX.connectionFinder.filterset).fadeTo("slow", 0.2);
                }
            }
        }).done(function (data) {
            $domobj.append($("<option>", {
                value: "",
                text: function () {
                    return $domobj.data("placeholder") || DECIX.connectionFinder.systemConfig.translations.choose;
                },
                selected: "selected",
                disabled: function () {
                    return $domobj.data("allowempty") ? false : "disabled";
                }
            }));
            // Check if data contains something or is empty and disable input if empty
            if (data.length > 0) {
                data.forEach(function (elem) {
                    $domobj.append($("<option>", {
                        value: elem.id,
                        text: elem.name
                    }));
                });
            } else {
                DECIX.connectionFinder.disableInput($domobj);
            }

            if (!DECIX.connectionFinder.mobileFilterToggle.is(":visible")) {
                $(DECIX.connectionFinder.filterset).fadeTo("slow", 1.0);
            }
            $domobj.trigger("fetchoptions:done");
        });
    };

    DECIX.connectionFinder.setupChangeHandler = function(domobj) {
        let $domobj = $(domobj);
        $domobj.unbind(".connectionFinder");
        $domobj.bind("change.connectionFinder", function(){
            if($domobj.val() !== "") {
                const next = $domobj.data("next");
                const nextparam = $domobj.val();
                const disables = $domobj.data("disables");
                const enables = $domobj.data("enables");
                const resets = $domobj.data("resets");

                $.each(disables, function(index, obj){
                    $(obj).find("option").remove();
                    DECIX.connectionFinder.disableInput($(obj));
                });

                $.each(enables, function(index, obj){
                    DECIX.connectionFinder.enableInput($(obj));
                });

                $.each(resets, function(index, obj){
                    if ($(obj).attr("type") === "checkbox") {
                        $(obj).prop("checked", false);
                    } else if ($(obj).prop("tagName").toLowerCase() === "select") {
                        $(obj).val($(this).find("option:first").val());
                    }
                });

                if($domobj.data("flushresults")) {
                    $(DECIX.connectionFinder.resultsContainer).empty().append(DECIX.connectionFinder.initialContent.show());
                }

                if($domobj.data("results")) {
                    if (typeof $domobj.data("results") === "string") {
                        const params = $domobj.data("resultsparams") || [];
                        DECIX.connectionFinder.updateResults($domobj, params);
                    } else if (typeof $domobj.data("results") === "object") {
                        // If data-results contains a list of elements, we find the next element that has a value and
                        // use that to update the results. We trigger the element's change event to update
                        // its next select as well.
                        let nextElement = null;
                        $domobj.data("results").forEach(function (element) {
                            if ($(element).val() && !$(element).attr("disabled")) {
                                nextElement = element;
                            }
                        });
                        if (nextElement) {
                            $(nextElement).trigger("change");
                        }
                    }
                }

                if($(next).data("source")) {
                    $(next).find("option").remove();

                    DECIX.connectionFinder.fetchOptions(next, nextparam);
                }
            } else if($domobj.data("allowempty")) {
                const prev = $domobj.data("onempty");
                $(prev).trigger("change");
            }
        });
    };

    /**
     * Populate href attributes with links to GCF on "Get connected" buttons and drop-downs
     */
    DECIX.connectionFinder.setupGetConnectedButtons = function () {
        let buttons = document.querySelectorAll(".single-button > a, .dropdown-button > .dropdown-button__dropdown > li > a");
        buttons.forEach((button) => {
            if(button.dataset.providerCategory.startsWith("DE-CIX")) {
                const argumentsString = "#" + button.dataset.locationName + "_" + button.dataset.datacenterName + "_" + button.dataset.city + "_" + button.dataset.country;
                button.href = DECIX.connectionFinder.gcfBaseUrl + argumentsString;
            }
        });
    };

    DECIX.connectionFinder.setupMobileFiltersToggle = function () {
        DECIX.connectionFinder.mobileFilterToggle.click(function (event) {
            event.preventDefault();
            $(this).toggleClass("active");
            DECIX.connectionFinder.filterset.toggleClass("expanded");
        });
    };

    /**
     * Flush current result list and insert new markup pulled via XHR request from given URI.
     *
     * @param source The source object to get request URI from
     * @param params Array with objects its values will be added to request URI
     */
    DECIX.connectionFinder.updateResults = function(source, params) {
        let sourceURI = DECIX.connectionFinder.URIs[$(source).data("results")];
        $.each(params, function(index, obj){
            sourceURI = sourceURI + "/" + $(obj).val();
        });

        $.ajax({
            accepts: {
                json: "application/json"
            },
            url: sourceURI + "/?locale=" + DECIX.connectionFinder.systemConfig["locale"] + "&onlyPartners=" + $("#connectionFinder__onlypartners").is(":checked"),
            beforeSend: function () {
                $(DECIX.connectionFinder.resultsContainer).fadeTo("slow", 0.2);
            }
        }).done(function(data){
            // Check if the data contains anything besides whitespace characters and is not empty
            if (/\S/.test(data) && data.length > 0) {
                $(DECIX.connectionFinder.resultsContainer).empty().append(data);
            } else {
                $(DECIX.connectionFinder.resultsContainer).empty().append(DECIX.connectionFinder.noResultsContent.show());
            }

            DECIX.connectionFinder.setupContactFormModal();
            DECIX.connectionFinder.setupGetConnectedButtons();
            $(DECIX.connectionFinder.resultsContainer).fadeTo("slow", 1.0);

            dropdownButton.apply();

            DECIX.connectionFinder.scrollToTopOfList();
        });
    };

    /**
     * Preselect country and city, if parameters are present in the URL
     */
    DECIX.connectionFinder.preSelect = function () {
        const uriAnchorValue = window.location.hash.substring(1);

        if (uriAnchorValue) {
            let anchor = decodeURIComponent(uriAnchorValue);

            if (anchor.split("_")[0] === "Location") {

                // #Location_Frankfurt
                let location = anchor.split("_")[1];

                DECIX.connectionFinder.locationSelect.on("fetchoptions:done", function () {
                    DECIX.connectionFinder.locationSelect.unbind("fetchoptions:done");

                    // Check if location exists and select it
                    let $locationOption = $("#connectionFinder__location option:contains(" + location + ")");
                    if ($locationOption.length > 0) {
                        DECIX.connectionFinder.locationSelect.val($locationOption.val());
                        DECIX.connectionFinder.locationSelect.trigger("change");
                    }
                });
            } else if (anchor.split("_")[0] === "Partners") {
                DECIX.connectionFinder.onlyPartnersCheckbox.prop("checked", true);
            } else {

                // #Germany_Frankfurt
                let country = anchor.split("_")[0];
                let city = anchor.split("_")[1];

                DECIX.connectionFinder.countrySelect.on("fetchoptions:done", function () {
                    DECIX.connectionFinder.countrySelect.unbind("fetchoptions:done");

                    // Check if country exists and select it
                    let $countryOption = $("#connectionFinder__country option:contains(" + country + ")");
                    if ($countryOption.length > 0) {
                        DECIX.connectionFinder.countrySelect.val($countryOption.val());

                        DECIX.connectionFinder.citySelect.on("fetchoptions:done", function () {
                            DECIX.connectionFinder.citySelect.unbind("fetchoptions:done");

                            // Check if city exists and select it
                            let $cityOption = $("#connectionFinder__city option:contains(" + city + ")");
                            if ($cityOption.length > 0) {
                                DECIX.connectionFinder.citySelect.val($cityOption.val()).trigger("change");
                            } else {
                                DECIX.connectionFinder.countrySelect.trigger("change");
                            }
                        });
                        DECIX.connectionFinder.fetchOptions(DECIX.connectionFinder.citySelect, $countryOption.val());
                    }
                });
            }
        }
    };

    /**
     * Setup missing connection button and modal
     */
    DECIX.connectionFinder.setupMissingConnectionModal = function () {
        DECIX.connectionFinder.missingConnectionButtons.click(function (event) {
            event.preventDefault();

            const missingConnectionModalData = {
                firstName: DECIX.connectionFinder.userData.attr("data-firstname"),
                lastName: DECIX.connectionFinder.userData.attr("data-lastname"),
                emailAddress: DECIX.connectionFinder.userData.attr("data-email")
            };

            const renderedModalTemplate = Mustache.render(document.getElementById("modalMissingConnectionTemplate").innerHTML, missingConnectionModalData);
            DECIX.connectionFinder.missingConnectionModal.html(renderedModalTemplate);
            DECIX.connectionFinder.missingConnectionModal.find("form").submit(function (event) {
                event.preventDefault();

                DECIX.connectionFinder.saveUserData($(this));

                $(this).find(".propertyError").html("");

                DECIX.connectionFinder.setButtonTextLoading(this);
                DECIX.connectionFinder.submitMissingConnectionModal();
            });
        });
    };

    DECIX.connectionFinder.submitMissingConnectionModal = function () {
        let $missingConnectionModal = DECIX.connectionFinder.missingConnectionModal;
        let $missingConnectionForm = $missingConnectionModal.find("form");
        const $actionUri = $missingConnectionForm.attr("action");

        $.ajax({
            type: "POST",
            url: $actionUri,
            data: $missingConnectionForm.serialize(),
            success: function (data) {
                let $missingConnectionModalContent = $missingConnectionModal.find(".modal__content");
                $missingConnectionModalContent.empty();
                $missingConnectionModalContent.append("<div class='modal__content'>" + data + "</div>");
            },
            error: function (data) {
                if (data.status === 400) {
                    const json = JSON.parse(data.responseText);
                    for (let key in json) {
                        $missingConnectionModal.find(".propertyError[aria-for='" + key + "']").html(json[key][0].message);
                    }
                }
                DECIX.connectionFinder.resetButtonText($missingConnectionForm);
            }
        });
    };

    /**
     * Reset current request button bindings and assign new to show modal form
     */
    DECIX.connectionFinder.setupContactFormModal = function(){

        let $dropdown = $("div#connectionFinder");  /* listen for clicks everywhere in the connection finder, so we can detect clicks  */
        $dropdown.unbind(".connectionFinder");
        $dropdown.on("click.connectionFinder", function (event) {
            var el = $(event.target),
                parentEl = el.parent(),
                name = event.target.nodeName;

            /* Toggle visibility of location options CTA "Get connected to" and "Request offer for" */
            if (name === "BUTTON" && el.hasClass("dropdown-toggle")) {
                if (parentEl.hasClass("open")) {
                    parentEl.removeClass("open");
                } else {
                    parentEl.addClass("open");
                }
            } else {
                var openEl = $(".cta-dropdown.open");
                if (openEl.length > 0) {
                    openEl.removeClass("open");
                }
            }
        });
        let $button = $(".dropdown-button__dropdown > li > a");
        $button.unbind(".connectionFinder");
        $button.on("click.connectionFinder", function (event) {
            const locationName = $(this).data("location-name");
            const dataCenter = $(this).data("datacenter-name");
            const city = $(this).data("city");
            const country = $(this).data("country");
            const connectionId = $(this).data("connection-id");
            const providerName = $(this).data("provider-name");
            const providerCategory = $(this).data("provider-category");

            if(!providerCategory.startsWith("DE-CIX")) {
                event.preventDefault();
                event.preventDefault();

                const formdata = {
                    connectionId: connectionId,
                    providerName: providerName,
                    datacenterName: dataCenter,
                    locationName: locationName,
                    city: city,
                    country: country,
                    firstName: DECIX.connectionFinder.userData.attr("data-firstname"),
                    lastName: DECIX.connectionFinder.userData.attr("data-lastname"),
                    emailAddress: DECIX.connectionFinder.userData.attr("data-email")
                };

                const renderedModalTemplate = Mustache.render(document.getElementById("modalContactFormTemplate").innerHTML, formdata);
                DECIX.connectionFinder.contactFormModal.html(renderedModalTemplate);
                MicroModal.show("modalContactForm");

                const form = DECIX.connectionFinder.contactFormModal.find("form");
                $(form).submit(function (event) {
                    event.preventDefault();

                    DECIX.connectionFinder.saveUserData(form);

                    $(form).find(".propertyError").html("");
                    DECIX.connectionFinder.setButtonTextLoading(this);
                    DECIX.connectionFinder.submitContactFormModal();
                });
            }
        });
        let $infoButton = $(".connection-finder__data-center .info-header__info-btn");
        $infoButton.unbind(".connectionFinder");
        $infoButton.on("click.connectionFinder", function () {
            const dataCenter = $(this).data("datacenter-name");
            const address = $(this).data("address");
            const suite = $(this).data("suite");
            const comment = $(this).data("datacenter-comment");
            const addressModalData = {
                dataCenter: dataCenter,
                address: address,
                comment: comment,
                suite: suite
            };

            const renderedModalTemplate = Mustache.render(document.getElementById("modalAdditionalInformationTemplate").innerHTML, addressModalData);
            DECIX.connectionFinder.additionalInformationModal.html(renderedModalTemplate);
            MicroModal.show("modalAdditionalInformation");
        });
    };

    DECIX.connectionFinder.submitContactFormModal = function () {
        let $contactFormModal = DECIX.connectionFinder.contactFormModal;
        let $contactForm = $contactFormModal.find("form");
        const url = $contactForm.attr("action");

        $.ajax({
            type: "POST",
            url: url,
            data: $contactForm.serialize(),
            success: function (data) {
                let $contactProviderModalBody = $contactFormModal.find(".modal__content");
                $contactProviderModalBody.empty();
                $contactProviderModalBody.append("<div class='modal__content'>" + data + "</div>");
            },
            error: function (data) {
                if (data.status === 400) {
                    const json = JSON.parse(data.responseText);
                    for (let key in json) {
                        $contactForm.find(".propertyError[aria-for='" + key + "']").html(json[key][0].message);
                    }
                }
                DECIX.connectionFinder.resetButtonText($contactForm);
            }
        });
    };

    /**
     * Scrolls the result list back to the top, if the filter set is at the top of the viewport ("stuck")
     */
    DECIX.connectionFinder.scrollToTopOfList = function () {
        $("html,body").animate({
            scrollTop: ($(DECIX.connectionFinder.resultsContainer).offset().top)
        }, "1000");
    };

    /**
     * Saves user data for other forms
     *
     * @param form The form from where to take the data
     */
    DECIX.connectionFinder.saveUserData = function (form) {
        DECIX.connectionFinder.userData.attr("data-firstname", $(form).find("#firstName").val());
        DECIX.connectionFinder.userData.attr("data-lastname", $(form).find("#lastName").val());
        DECIX.connectionFinder.userData.attr("data-email", $(form).find("#emailAddress").val());
    };

    /**
     * Sets the loading text for the submit button of a form and saves the
     * original text in a data attribute
     *
     * @param form
     */
    DECIX.connectionFinder.setButtonTextLoading = function (form) {
        const $submitButton = $(form).find("button");
        const $loadingText = $submitButton.data("loading-text");
        const $defaultText = $submitButton.find(".cta__text").text();
        $submitButton.attr("data-default-text", $defaultText);
        $submitButton.find(".cta__text").text($loadingText);
    };

    /**
     * Resets the submit button text of a form to the default value
     * @param form
     */
    DECIX.connectionFinder.resetButtonText = function (form) {
        const $submitButton = $(form).find("button");
        const $defaultText = $submitButton.data("default-text");
        if ($defaultText) {
            $submitButton.find(".cta__text").text($defaultText);
        }
    };

    DECIX.connectionFinder.disableInput = function ($input) {
        $input.attr("disabled", true);

        if ($input.attr("type") === "checkbox") {
            $input.parents("div.input").addClass("disabled");
        } else if ($input.prop("tagName").toLowerCase() === "select") {
            let $selectWrapper = $input.parent(".select-wrapper");
            $selectWrapper.addClass("disabled");
        }
    };

    DECIX.connectionFinder.enableInput = function ($input) {
        $input.attr("disabled", false);

        if ($input.attr("type") === "checkbox") {
            $input.parents("div.input").removeClass("disabled");
        } else if ($input.prop("tagName").toLowerCase() === "select") {
            let $selectWrapper = $input.parent(".select-wrapper");
            $selectWrapper.removeClass("disabled");
        }
    };

    /**
     * Initialize ConnectionFinder and update initial selectpicker.
     */
    DECIX.connectionFinder.init = function() {
        $(DECIX.connectionFinder.resultsContainer).empty().append(DECIX.connectionFinder.initialContent.show());
        DECIX.connectionFinder.setSystemConfig();
        DECIX.connectionFinder.setAjaxURIs();
        DECIX.connectionFinder.setupMissingConnectionModal();
        DECIX.connectionFinder.setupMobileFiltersToggle();

        [
            DECIX.connectionFinder.countrySelect,
            DECIX.connectionFinder.citySelect,
            DECIX.connectionFinder.locationSelect,
            "#connectionFinder__datacenter",
            DECIX.connectionFinder.onlyPartnersCheckbox
        ].map(DECIX.connectionFinder.setupChangeHandler);

        // Explicitly disable selects just to be safe
        $("#connectionFinder__city, #connectionFinder__datacenter").each(function () {
            DECIX.connectionFinder.disableInput($(this));
        });

        DECIX.connectionFinder.preSelect();

        DECIX.connectionFinder.fetchOptions(DECIX.connectionFinder.countrySelect);
        DECIX.connectionFinder.fetchOptions(DECIX.connectionFinder.locationSelect);

    };

    DECIX.connectionFinder.init();

});
